import toast, {Toaster} from "react-hot-toast";

const OneToastContainer = () => {
  return <Toaster />;
};

export {OneToastContainer, toast};
